import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import { logout } from 'meteor-apollo-accounts'
import contextUrl from '../../../Root/contextUrl'

export default class NoVerified extends React.Component {
  static propTypes = {
    client: PropTypes.object,
    showMessage: PropTypes.func,
    resendVerificationEmail: PropTypes.func,
    me: PropTypes.func
  }

  state = {}

  @autobind
  async logout() {
    await logout(this.props.client)
  }


  render() {
    console.log('Route NoActive');
    var logo = '/logo.png'
    var context = contextUrl;
    if(context === 'pi.tufirma.digital' || context === 'test.tufirma.digital' || context === 'portalinmobiliario.tufirma.digital' ){
      logo='/logoportal.png'
    }

    return (
      <div className={styles.root}>
        <div className={styles.paperContainer}>
          <div className={styles.logo}>
            <img src={logo} alt="Tu Firma Digital" />
          </div>
          <h2 className={styles.title}>Hola, tu cuenta no está activada,</h2>
          <div className={styles.content}>LOREM IPSUM 1</div>
          <div className={styles.content}>LOREM IPSUM 2</div>

          <div className={styles.logout}>
            <a onClick={this.logout} className={styles.menuLink}>
              <span>Cerrar Sesión</span>
            </a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/NoActive/index.js